import {
  LIST_DATASETS_ROUTE,
  CREATE_DATASET_ROUTE,
  GET_DATASET_ROUTE,
  UPDATE_DATASET_ROUTE,
  DELETE_DATASET_ROUTE,
  LIST_ITEMS_ROUTE,
  ADD_ITEM_ROUTE,
  GET_ITEM_ROUTE,
  UPDATE_ITEM_ROUTE,
  DELETE_ITEM_ROUTE,
  LIST_ALL_EXPERIMENTS_ROUTE,
  EXPERIMENT_REVIEW_SUMMARY_ROUTE,
  LIST_EXPERIMENTS_ROUTE,
  TRIGGER_EXPERIMENT_ROUTE,
  GET_EXPERIMENT_ROUTE,
  LIST_EXPERIMENT_RESULTS_ROUTE,
  UPDATE_EXPERIMENT_RESULT_ROUTE,
  COMPARE_EXPERIMENTS_ROUTE,
  LIST_DATASET_VERSIONS_ROUTE,
  LIST_ITEM_VERSIONS_ROUTE,
  GET_ITEM_VERSION_ROUTE,
  BATCH_INSERT_ITEMS_ROUTE,
  BATCH_DELETE_ITEMS_ROUTE,
  GENERATE_ITEMS_ROUTE,
  CLUSTER_FAILURES_ROUTE,
} from '../../handlers/datasets';

export const DATASETS_ROUTES = [
  // Dataset CRUD
  LIST_DATASETS_ROUTE,
  CREATE_DATASET_ROUTE,
  GET_DATASET_ROUTE,
  UPDATE_DATASET_ROUTE,
  DELETE_DATASET_ROUTE,
  // Item list and add
  LIST_ITEMS_ROUTE,
  ADD_ITEM_ROUTE,
  // Batch operations - MUST come before item-specific routes to avoid /items/batch matching /items/:itemId
  BATCH_INSERT_ITEMS_ROUTE,
  BATCH_DELETE_ITEMS_ROUTE,
  // Item-specific CRUD (uses :itemId param)
  GET_ITEM_ROUTE,
  UPDATE_ITEM_ROUTE,
  DELETE_ITEM_ROUTE,
  // Version operations
  LIST_DATASET_VERSIONS_ROUTE,
  LIST_ITEM_VERSIONS_ROUTE,
  GET_ITEM_VERSION_ROUTE,
  // All experiments (cross-dataset) - MUST come before dataset-scoped experiments
  LIST_ALL_EXPERIMENTS_ROUTE,
  // Experiment review summary (cross-dataset) - MUST come before dataset-scoped experiments
  EXPERIMENT_REVIEW_SUMMARY_ROUTE,
  // Experiment operations (dataset-scoped)
  LIST_EXPERIMENTS_ROUTE,
  TRIGGER_EXPERIMENT_ROUTE,
  GET_EXPERIMENT_ROUTE,
  LIST_EXPERIMENT_RESULTS_ROUTE,
  UPDATE_EXPERIMENT_RESULT_ROUTE,
  // Analytics
  COMPARE_EXPERIMENTS_ROUTE,
  // AI generation
  GENERATE_ITEMS_ROUTE,
  // Failure analysis
  CLUSTER_FAILURES_ROUTE,
] as const;
